export enum StepStatusEnum {
  BACKOFFICE_PENDING = "BACKOFFICE_PENDING",
  CAR_WORKSHOP_PENDING = "CAR_WORKSHOP_PENDING",
  PENDING_FLEET_ADM_TECHNICAL = "PENDING_FLEET_ADM_TECHNICAL",
  PENDING_BUDGET_VALIDATION = "PENDING_BUDGET_VALIDATION",
  BUDGET_APPROVAL = "BUDGET_APPROVAL",
  FLEET_ADMIN_APPROVAL = "FLEET_ADMIN_APPROVAL",
  VEHICLE_ATTENDANCE_PENDING = "VEHICLE_ATTENDANCE_PENDING",
  VEHICLE_EVALUATION = "VEHICLE_EVALUATION",
  SERVICE_RUNNING = "SERVICE_RUNNING",
  SERVICE_COMPLETED = "SERVICE_COMPLETED",
  DISAPPROVED = "DISAPPROVED",
  CANCELED = "CANCELED"
}
